import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorList, InputLabelWrapper } from '@guildeducationinc/recess';
import { Editor } from '@tinymce/tinymce-react';
import classNames from 'classnames';
import { useState } from 'react';
export const HtmlEditor = ({ value, label, hideLabel, errors, additionalInfo, helpText, onChange, disabled = false, minimal = false, hideToolbar = false, autoResize = false, }) => {
    const [editorRef, setEditorRef] = useState(null);
    const errorList = errors ? (Array.isArray(errors) ? errors : [errors]) : [];
    const handleEditorChange = (content) => {
        onChange(content);
    };
    let toolbar = '';
    if (!hideToolbar) {
        if (minimal) {
            toolbar =
                'bold italic | alignleft aligncenter alignright alignjustify | link | bullist numlist | removeformat';
        }
        else {
            toolbar =
                'undo redo | code fullscreen | formatselect | styles | ' +
                    'bold italic forecolor backcolor | alignleft aligncenter | link | ' +
                    'alignright alignjustify | bullist numlist outdent indent | hr | ' +
                    'removeformat | help';
        }
    }
    return (_jsxs(_Fragment, { children: [editorRef && (_jsx(InputLabelWrapper, { inputId: editorRef.id, hideLabel: hideLabel, label: label, additionalInfo: additionalInfo, helpText: helpText })), _jsx(Editor, { tinymceScriptSrc: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce/6.2.0/tinymce.min.js', onInit: (_evt, editor) => setEditorRef(editor), value: value, init: {
                    forced_root_block: 'div',
                    height: 300,
                    menubar: false,
                    plugins: classNames('code help link lists fullscreen', { autoresize: autoResize }),
                    toolbar,
                    //
                    // Note: it seems like 'style' doesn't have any effect when added to valid_elements and/or
                    // extended_valid_elements -- TinyMCE removes the style tags when you save.
                    // Maybe TinyMCE inherently prevents using the style tag.
                    // valid_elements: '*[*],style',
                    // extended_valid_elements: 'style',
                    extended_valid_elements: 'svg[*],path[*]',
                }, onEditorChange: handleEditorChange, disabled: disabled }), _jsx(ErrorList, { errors: errorList, show: errorList.length > 0, global: false })] }));
};
